import React from 'react';
import './PhoneAIChat.css';

// One message bubble. `role` is one of 'user' | 'assistant' | 'tool'.
// Tool messages are rendered as a small collapsed "tool result" chip rather
// than a full bubble so the chat stays readable.
const PhoneAIMessageBubble = ({ role, content, toolName, toolsUsed }) => {
  if (role === 'tool') {
    return (
      <div className="phoneai-tool-row" title={content}>
        <span className="phoneai-tool-chip">{toolName ? `↳ ${toolName}` : '↳ tool'}</span>
      </div>
    );
  }

  const isUser = role === 'user';
  return (
    <div className={`phoneai-row ${isUser ? 'phoneai-row--user' : 'phoneai-row--assistant'}`}>
      <div className={`phoneai-bubble ${isUser ? 'phoneai-bubble--user' : 'phoneai-bubble--assistant'}`}>
        <div className="phoneai-bubble-content">{content}</div>
        {!isUser && Array.isArray(toolsUsed) && toolsUsed.length > 0 && (
          <div className="phoneai-bubble-tools">
            {toolsUsed.map((t, i) => (
              <span key={`${t}-${i}`} className="phoneai-tool-chip phoneai-tool-chip--mini">{t}</span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PhoneAIMessageBubble;
